// Phase 34 — global offline indicator. Listens to the browser online/offline
// events and shows a slim banner when connectivity drops, so users understand
// why data stopped updating (rather than assuming the app is broken).

import { useEffect, useState } from 'react';
import { WifiOff } from 'lucide-react';

export function OfflineIndicator() {
  const [offline, setOffline] = useState(typeof navigator !== 'undefined' && !navigator.onLine);

  useEffect(() => {
    const on = () => setOffline(false);
    const off = () => setOffline(true);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => { window.removeEventListener('online', on); window.removeEventListener('offline', off); };
  }, []);

  if (!offline) return null;
  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[100] animate-fade-in">
      <div className="flex items-center gap-2 px-4 py-2.5 rounded-full bg-amber-500/95 text-black text-sm font-semibold shadow-xl">
        <WifiOff className="h-4 w-4" />
        You’re offline — reconnecting…
      </div>
    </div>
  );
}
